import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "LB_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#LB_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M32 0H0v6h32V0zm0 18H0v6h32v-6z", fill: "#F50101" }), /* @__PURE__ */ e.createElement("path", { d: "M0 6h32v12H0V6z", fill: "#F7FCFF" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.515 12.513c.075.867-3.126-.36-3.126-.012 0 .347 3.429.957 3.423 1.734-.006.777-4.066-.222-3.155.128.91.35 2.865 1.186 2.643 1.708-.475 1.113-3.626-.773-3.888-.401-.423.6 2.325 1.999 2.302 2.132-.045.257-1.877-.402-2.302.13-.345-.097-.504-.56-.61-.622l-.677-8.724s.608 8.214-.168 8.45c-.776.236-2.932.954-2.995.596-.023-.134 2.596-1.362 2.173-1.962-.312-.442-3.472 1.125-3.674.218-.898-.648 2.91-1.208 2.91-1.87 0-.662-3.484.784-3.067-.138.417-.922 3.205-1.252 3.257-1.38.095-.233-3.1.364-3.1 0 0-.687 1.912-.822 3.1-1.441.07-.707-2.88.695-3.1.129-.219-.566 3.771-2.033 3.674-2.147-.155-.18-3.37.634-2.84.206 1.03-.83 3.038-1.958 3.5-2.26 0 0 .056-.113.116-.074l.125-.081s0 .71-.01.156c-.01-.554 4.71 1.87 4.763 2.486.063.718-2.916-.542-2.846.164.606.376 2.328 1.101 3.04 1.42.322.145-2.379-.306-2.322-.084.146.564 2.776.634 2.854 1.54z",
      fill: "#52AB0B"
    }
  ))
), a = t;
export {
  a as default
};
